import { writeCache } from 'lib/indexedDbCache';

import { buildAccountUsersCacheKey } from './buildAccountUsersCacheKey';

/**
 * Stores the account's PK_User → UUID pairs, replacing the bucket contents and refreshing its
 * last-access time. Callers pass the pairs restricted to the account's current users, so users
 * deleted upstream drop out of the cache (no orphaned mappings accumulate). When the environment is
 * unknown the key is `null` and we skip the write rather than cache under an unscoped key.
 *
 * @param {string|number} PK_Account - Account whose bucket to write.
 * @param {Object} pairs - PK_User → UUID pairs to persist (current users only).
 * @returns {Promise<void>}
 */
export const writeAccountUsersBucket = async (PK_Account, pairs) => {
    const key = buildAccountUsersCacheKey(PK_Account);
    if (!key) {
        return;
    }

    await writeCache(key, { pairs }, { lastAccessedAt: Date.now() });
};
